import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { AssetLibraryProps } from "./AssetLibrary";
const AssetLibrary = lazy(() => import("./AssetLibrary").then(module => ({ default: module.AssetLibrary })));

export function mountAssetLibrary(slot: HTMLElement, props: AssetLibraryProps) {
  setStudioView("app", "asset-library", <AssetLibrary key={props.projectId || "personal"} {...props} />);
}
